import React from 'react';
import { MainLayout } from '@/components/MainLayout';
import { SimpleCostCenterPage } from '@/components/cost-centers/SimpleCostCenterPage';

export default function CostCentersPage() {
  return (
    <MainLayout>
      <SimpleCostCenterPage />
    </MainLayout>
  );
}

